export default "__VITE_ASSET__DacAZkts__"